import { Ng2StateDeclaration } from '@uirouter/angular';
import * as fromInvoice from '.';
import { LoggingService } from '../../shared/services/logging/logging.service';

const log = new LoggingService();

export const InvoiceDateRangeRoute: Ng2StateDeclaration = {
    // name: 'invoice.**'
    name: 'invoice.daterange',
    url: '/daterange',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.invoiceModule)
    data: { requiresAuth: true },
    component: fromInvoice.InvoiceSessionNumberContainerComponent
};
